<app-page-header title="Home" active_item="Extrato"></app-page-header>
<form [formGroup]="extrato">
<div class="row">
  <h5>Extrato de Transações</h5>
  <div class="col-md-12 col-xl-12">
    <div class="card sales-summary shadow" [ngClass]="{'rounded-10': !isFilterColapsed, 'rounded-10-top': isFilterColapsed}">
      <div class="card-header">
        <div class="card-title mb-0">Filtros</div>
        <div class="card-options">
          <a href="javascript:void(0)" class="card-options-collapse" data-bs-toggle="card-collapse"
             (click)="filterColapse()" [attr.aria-expanded]="!isFilterColapsed"><i
            class="fe fe-chevron-{{ !isFilterColapsed ? 'up' : 'down'}}"></i></a>
        </div>
      </div>
      <div class="card-body filter-extrato" [(ngbCollapse)]="isFilterColapsed">
        <div class="row">
          <div class="col-xl col-lg-6 col-sm-6">
            <div class="form-group">
              <label for="slTransactionType" class="form-label">Tipo</label>
              <ng-select id="slTransactionType" [clearable]="false" [items]="transactionTypes" bindValue="value" bindLabel="name"  [formControl]="extrato.controls.tipo" />
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6">
            <div class="form-group">
              <label for="slStatus" class="form-label">Status</label>
              <ng-select id="slStatus" [clearable]="false" [items]="statusList" bindValue="value" bindLabel="name" [formControl]="extrato.controls.status" />
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6">
            <div class="form-group">
              <label class="form-label">Data inicial</label>
              <div class="input-group">
                <input [formControl]="extrato.controls.initialDate" class="form-control" placeholder="dd/MM/YYYY" name="dataInitial"
                       ngbDatepicker #dtIni="ngbDatepicker" [ngClass]="{'is-invalid state-invalid': extrato.controls.initialDate.invalid && isSubmitted}"/>
                <div class="input-group-append">
                  <i class="fa fa-calendar btn btn-md btn-default lh-lg"  (click)="dtIni.toggle()"></i>
                </div>
                <div class="invalid-feedback">Data inicial obrigatória!</div>
              </div>
            </div>
          </div>
          <div class="col-xl col-lg-6 col-sm-6">
            <div class="form-group">
              <label class="form-label">Data final</label>
              <div class="input-group">
                <input class="form-control" placeholder="dd/MM/YYYY" name="dataFinal" [formControl]="extrato.controls.endDate" ngbDatepicker #dtFim="ngbDatepicker"
                       [ngClass]="{'is-invalid state-invalid': extrato.controls.endDate.invalid && isSubmitted}"/>
                <div class="input-group-append">
                  <i class="fa fa-calendar btn btn-md btn-default lh-lg"  (click)="dtFim.toggle()"></i>
                </div>
                <div class="invalid-feedback">Data final obrigatória!</div>
              </div>
            </div>
          </div>

        </div>
        <div class="row">
          <div class="col-xl-3 col-lg-4 col-sm-6">
            <div class="form-group">
              <label for="slOrigin" class="form-label">Origem</label>
              <ng-select id="slOrigin" [clearable]="false" [items]="originList" bindValue="value" bindLabel="name" [formControl]="extrato.controls.origem"/>
            </div>
          </div>
          <div class="col-xl-3 col-lg-4 col-sm-6">
            <div class="form-group">
              <label for="slOrigin" class="form-label">Aplicação</label>
              <ng-select id="slOrigin" [clearable]="false" [items]="applicationList" bindValue="value" bindLabel="name"  [formControl]="extrato.controls.aplicacao" />
            </div>
          </div>
          <div class="col-xl-2 col-lg-6 col-sm-6">
            <div class="form-group">
              <label for="slTipoBusca" class="form-label">Tipo de Busca</label>
              <ng-select id="slTipoBusca" [clearable]="false" [items]="tipoBuscaList" bindValue="value" bindLabel="name" [formControl]="extrato.controls.tipoBusca" />
            </div>
          </div>
          <div class="col-xl-3 col-lg-6 col-sm-6">
            <div class="form-group">
              <label for="txtDescricao" class="form-label">Busca</label>
              <input class="form-control" type="text" name="descricao" id="txtDescricao" bindValue="value" [formControl]="extrato.controls.responsavel">
            </div>
          </div>
          <div class="col-xl-1 col-lg-6 col-sm-6">
            <button type="button" class="our-button btn btn-pill btn-primary" (click)="buscar()"><i class="fe fe-search me-2"></i>Buscar</button>
         </div>
        </div>
      </div>
    </div>
  </div>
  <div class="loading-extrato" *ngIf="!isLoaded">
    <div class="dimmer active">
      <div class="lds-ring">
        <div></div>
      </div>
    </div>
  </div>
  <div class="col-md-12 col-xl-12">
    <div class="card rounded-10 shadow">
      <div class="row">
        <div class="col-xl col-lg-6 col-sm-6 px-0">
          <div class="card-body text-center">
            <div class="d-flex">
              <span class="avatar avatar-md rounded-3 bg-success-transparent text-success me-3">
                <i class="fa fa-caret-up"></i>
              </span>
              <div class="me-2">
                <span class="mb-1 fs-13 font-weight-500 text-muted me-3">A Receber</span>
                <p class="fs-15 me-3 mb-0 font-weight-semibold">R$ {{aReceber| mask: 'separator.2': {decimalMarker: ',', leadZero: true, thousandSeparator: '.'} }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl col-lg-6 col-sm-6 px-0">
          <div class="card-body text-center">
            <div class="d-flex">
                <span class="avatar avatar-md rounded-3 bg-success-transparent text-success me-3">
                  <i class="fa fa-caret-up"></i>
                </span>
              <div class="me-2">
                <span class="mb-1 fs-13 font-weight-500 text-muted me-3">Recebimentos</span>
                <p class="fs-15 me-3 mb-0 font-weight-semibold">R$ {{recebimento| mask: 'separator.2': {decimalMarker: ',', leadZero: true, thousandSeparator: '.'} }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl col-lg-6 col-sm-6 px-0">
          <div class="card-body text-center">
            <div class="d-flex">
                <span class="avatar avatar-md rounded-3 bg-success-transparent text-success me-3">
                  <i class="fa fa-caret-up"></i>
                </span>
              <div class="me-2">
                <span class="mb-1 fs-13 font-weight-500 text-muted me-3">Ticket Médio</span>
                <p class="fs-15 me-3 mb-0 font-weight-semibold">R$ {{ticketMedioRecebimento| mask: 'separator.2': {decimalMarker: ',', leadZero: true, thousandSeparator: '.'} }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl col-lg-6 col-sm-6 px-0">
          <div class="card-body text-center">
            <div class="d-flex">
                <span class="avatar avatar-md rounded-3 bg-success-transparent text-success me-3">
                  <i class="fa fa-caret-up"></i>
                </span>
              <div class="me-2">
                <span class="mb-1 fs-13 font-weight-500 text-muted me-3">Conversão</span>
                <p class="fs-15 me-3 mb-0 font-weight-semibold">{{conversao| mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}%</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl col-lg-6 col-sm-6 px-0">
          <div class="card-body text-center">
            <div class="d-flex">
              <a href="javascript:void(0)">
                <span class="avatar avatar-md rounded-3 bg-danger-transparent text-danger me-3">
                  <i class="fa fa-caret-down"></i>
                </span>
              </a>
              <div class="me-2">
                <a href="javascript:void(0)">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3">Saques</span>
                </a>
                <p class="fs-15 me-3 mb-0 font-weight-semibold">R$ {{saque| mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl col-lg-6 col-sm-6 px-0">
          <div class="card-body text-center">
            <div class="d-flex">
              <a href="javascript:void(0)">
                <span class="avatar avatar-md rounded-3 bg-danger-transparent text-danger me-3">
                  <i class="fa fa-caret-down"></i>
                </span>
              </a>
              <div class="me-2">
                <a href="javascript:void(0)">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3">Pendentes</span>
                </a>
                <p class="fs-15 me-3 mb-0 font-weight-semibold">R$ {{saquePendente| mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl col-lg-6 col-sm-6 px-0">
          <div class="card-body text-center">
            <div class="d-flex">
              <a href="javascript:void(0)">
                <span class="avatar avatar-md rounded-3 bg-primary-transparent text-danger me-3">
                  <i class="fa fa-caret-up text-primary"></i>
                </span>
              </a>
              <div class="me-2">
                <a href="javascript:void(0)">
                  <span class="mb-1 fs-13 font-weight-500 text-muted me-3">Saldo Final</span>
                </a>
                <p class="fs-15 me-3 mb-0 font-weight-semibold">R$ {{saldoFinal| mask: 'separator.2': {decimalMarker: ',', leadZero: true} }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">Transações</div>
        <div class="card-options">
          <button type="button" class="btn btn-pill btn-default-light" (click)="downloadFile()" ><i class="fe fe-download me-2"></i>Exportar</button>
        </div>
      </div>
      <div class="card-body button-table">
        <app-table-transactions></app-table-transactions>
      </div>
    </div>
  </div>
</div>
</form>
